export var PersonRole;
(function (PersonRole) {
    PersonRole["ALTERNATIVE_BENEFICIAL_OWNER"] = "ALTERNATIVE_BENEFICIAL_OWNER";
    PersonRole["LEGAL_REPRESENTATIVE"] = "LEGAL_REPRESENTATIVE";
    PersonRole["OWNER"] = "OWNER";
    PersonRole["ULTIMATE_BENEFICIAL_OWNER"] = "ULTIMATE_BENEFICIAL_OWNER";
})(PersonRole || (PersonRole = {}));
